import { Modal, Button as AntButton } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEmployees } from '../../../../../../../api/employees.api';
import { RootState } from '../../../../../../../store/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';
import useAxios from '../../../../../../../hooks/useAxios';
import { IGetEmployees } from '../../../../../../../models/employees.model';
import qs from 'qs';
import { useHistory, useLocation } from 'react-router-dom';
import CounselorContents from './CounselorContents';
import {
  getExamineeDetail,
  updateCounselor,
} from '../../../../../../../api/placeTest.api';
interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  data?: any;
  platRequireCode?: number | null;
  onChangeModal?: (isOpen: boolean) => void;
}

const CounselorModal: FC<IProps> = ({
  visible,
  setVisible,
  data,
  platRequireCode,
  onChangeModal,
}) => {
  const location = useLocation();
  const history = useHistory();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, execute } = useAxios<IGetEmployees>();
  const { execute: executeCounselor } = useAxios<any>();
  const { execute: executeExamineeDeatail } = useAxios<any>();
  const { t } = useTranslation();
  const [param, setParam] = useState({});
  const [isSelect, setIsSelect] = useState(false);
  const { memberCode } = useSelector(
    (state: RootState) => state.entranceCounselor,
    shallowEqual,
  );

  useEffect(() => {
    execute(getEmployees({ campusCode: currentCampus, all: 'Y' }));
  }, []);

  const saveHandlerCounselor = () => {
    console.log('platRequireCode', platRequireCode);
    console.log('memberCode', memberCode);
    executeCounselor(updateCounselor(platRequireCode, memberCode));
    setVisible(false);
  };

  const handlerCheckSelected = (value: boolean) => {
    setIsSelect(value);
  };
  return (
    <>
      <Modal
        title={t('entrance.schedule.title13')}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={750}
        footer={[
          <div className="comm-btn__area justify-content-center">
            <AntButton
              key="save"
              className="btn-basic pink"
              onClick={saveHandlerCounselor}
              disabled={!isSelect}
            >
              {t('common.button.save')}
            </AntButton>
            <AntButton
              key="cancel"
              className="btn-basic gray"
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>,
        ]}
      >
        <CounselorContents
          employees={
            res?.data?.filter((item: any) => item?.employeeStatus !== '02') ||
            []
          }
          param={param}
          onChangeSelect={handlerCheckSelected}
        />
      </Modal>
    </>
  );
};

export default CounselorModal;
